export default {
  1: 'linear-gradient(187deg,#c5ff88 -15%, #96d722 38%, #5ca406 187%)',
  2: 'linear-gradient(5deg,#5503c2 -29%, #6434ff 33%, #a888ff 94%)',
  3: 'linear-gradient(5deg, #c23d03 -29%, #ffb734 33%, #ffde64 94%)',
};
